@if (showBanner) {
    <div
        class="trial-banner-container"
        [ngClass]="currentClientModule | timeTrialBannerClass: showBanner"
    >
        <span class="remaining-days-section">{{ messageContent }}</span>
        <span class="upgrade-message">{{ upgradeMessageKey | translate }}</span>
        <span
            class="lock-section"
            piTesting="bannerClickUpgradeNow"
            (click)="upgradeAccount()"
        >
            <tapestry-icon [size]="iconSize" name="unlock"></tapestry-icon>
            <span class="unlock-text">{{
                'timeTrial.upgradeNow' | translate
            }}</span>
        </span>
    </div>
}
